import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

const Navigation = (idtrain) => {
  const navItems = [
    { id: 1, text: 'Formation' },
    { id: 2, text: 'Compétences' },
    { id: 3, text: 'FAQ' },
  ];
  const [activeTab, setActiveTab] = useState("Formation");
  return (
    <>
      <nav className="navigation">
        {console.log(idtrain)}
        {navItems.map((item) => (
          <React.Fragment key={item.id}>
            <a href={`../${item.text.toLowerCase()}/${idtrain.idtrain}`} className="nav-item">
              {item.text}
            </a>
            {item.id === 1 && <div className="nav-underline" />}
          </React.Fragment>
        ))}
        <style jsx>{`
        .navigation {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 20px;
          color: #000;
          font-weight: 400;
          width : 25%;
          position: fixed;
          left: 0%;
          top:36%
        }
        .nav-item {
          font-family: Montserrat, sans-serif;
          font-weight: 500;
          text-decoration: none;
          color: inherit;
          margin-bottom: 20px;
        }
        .nav-underline {
          width: 111px;
          height: 2px;
          background-color: #2daae2;
          position: fixed;
          top: 39.5%
        }
        @media (max-width: 991px) {
          .navigation {
            margin-top: 40px;
          }
        }
      `}</style>
      </nav>
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container">
          <ul className="navbar-nav mx-auto">
            <li
              className={`nav-item ${activeTab === "Formation" ? "active" : ""}`}
              onClick={() => Navigate}
            >
              <a href={`../formation/${idtrain.idtrain}`} className="nav-item">
                <span className="nav-link">Formation</span>
              </a>
            </li>
            <li
              className={`nav-item ${activeTab === "Compétences" ? "active" : ""}`}
              onClick={() => setActiveTab("Compétences")}
            >
              <a href={`../compétences/${idtrain.idtrain}`} className="nav-item">
                <span className="nav-link">Compétences</span>
              </a>
            </li>
            <li
              className={`nav-item ${activeTab === "FAQ" ? "active" : ""}`}
              onClick={() => setActiveTab("FAQ")}
            >
              <a href={`../faq/${idtrain.idtrain}`} className="nav-item">
                <span className="nav-link">FAQ</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navigation;